import React from "react";
import s from "./RemoveObject.module.scss";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import { removeObjectAction } from "../../redux/reducers/ui/actions/actions";
import { getActiveObjectId } from "../../redux/reducers/ui/selectors/objectSelectors";
import { RemoveIconSVG } from "../../assets/svg/RemoveIcon";

export const RemoveObject: React.FC = () => {
  const dispatch = useAppDispatch();
  const activeObjectId = useAppSelector(getActiveObjectId);
  const handleRemoveObject = () => {
    if (!activeObjectId) return;
    dispatch(removeObjectAction({ productId: activeObjectId }));
  };

  if (!activeObjectId) {
    return null;
  }

  return (
    <div className={s.remove_object_container}>
      <button className={s.confirm_remove} onClick={handleRemoveObject}>
        <RemoveIconSVG />
        <div className={s.text}>Remove</div>
      </button>
    </div>
  );
};
